var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Fornecedores","p-read-link":"providers.read.one","p-create-link":"providers.create","p-name":"peoples"}})}
var staticRenderFns = []

export { render, staticRenderFns }